import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=4276bc06&scoped=true"
import script from "./DocList.vue?vue&type=script&lang=js"
export * from "./DocList.vue?vue&type=script&lang=js"
import style0 from "./DocList.vue?vue&type=style&index=0&id=4276bc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276bc06",
  null
  
)

export default component.exports